// @ts-nocheck
(function () {
  "use strict";

  var STORAGE_PREFIX = "qbsAutoPopupDismissed:";

  function storageKey(handle) {
    return STORAGE_PREFIX + handle;
  }

  function wasDismissed(handle) {
    try {
      return window.localStorage.getItem(storageKey(handle)) === "true";
    } catch (e) {
      return false;
    }
  }

  function markDismissed(handle) {
    try {
      window.localStorage.setItem(storageKey(handle), "true");
    } catch (e) {
      // Storage unavailable (private mode, disabled cookies, etc.) - fail silently.
    }
  }

  function initPopup(root) {
    var handle = root.dataset.autoPopupHandle;
    if (!handle || wasDismissed(handle)) return;

    var delaySeconds = parseFloat(root.dataset.autoPopupDelay);
    var delayMs = (isNaN(delaySeconds) ? 3 : delaySeconds) * 1000;

    var timerId = window.setTimeout(function () {
      if (window.flsModules && window.flsModules.popup) {
        window.flsModules.popup.open("#" + root.id);
      }
    }, delayMs);

    // Any close path (X button, overlay click, Esc) dispatches this event
    // from the shared popup module, so a single listener covers them all.
    document.addEventListener("afterPopupClose", function onClose(e) {
      if (e.detail && e.detail.popup && e.detail.popup.previousOpen.element === root) {
        window.clearTimeout(timerId);
        markDismissed(handle);
        document.removeEventListener("afterPopupClose", onClose);
      }
    });

    // Clicking a CTA link navigates away immediately, before the close
    // event above has a chance to fire - mark it dismissed right away so
    // the destination page doesn't show the same popup again.
    root.querySelectorAll("a[href]").forEach(function (link) {
      link.addEventListener("click", function () {
        window.clearTimeout(timerId);
        markDismissed(handle);
      });
    });
  }

  function init() {
    document.querySelectorAll("[data-qbs-auto-popup]").forEach(initPopup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
